import { Link } from "react-router-dom"
import {Diamond, ExternalLink} from 'lucide-react'

export default function Footer() {
  return (
    <footer className="bg-black border-t border-yellow-900/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Diamond className="w-6 h-6 text-yellow-500" />
              <span
                className="text-xl font-bold tracking-wider gold-shimmer"
                style={{ fontFamily: "'Orbitron', sans-serif" }}
              >
                BLINGSKINS
              </span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs">
              The ultimate destination for gamers who care about style as much as skill. Discover the rarest, flashiest cosmetics across your favorite games.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="text-yellow-500 font-bold text-sm uppercase tracking-widest mb-4"
              style={{ fontFamily: "'Orbitron', sans-serif" }}
            >
              Quick Links
            </h4>
            <ul className="space-y-2">
              {[
                { to: "/", label: "Home" },
                { to: "/lifeline-bling", label: "Lifeline Bling" },
                { to: "/fortnite-bling", label: "Fortnite Bling" },
                { to: "/valorant-bling", label: "Valorant Bling" },
                { to: "/blog", label: "Latest Bling" },
                { to: "/about", label: "About Us" },
                { to: "/admin", label: "Content Manager" },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-gray-500 hover:text-yellow-400 text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Featured Games */}
          <div>
            <h4
              className="text-yellow-500 font-bold text-sm uppercase tracking-widest mb-4"
              style={{ fontFamily: "'Orbitron', sans-serif" }}
            >
              Featured Games
            </h4>
            <ul className="space-y-2">
              {[
                { name: "Apex Legends", to: "/lifeline-bling" },
                { name: "Fortnite", to: "/fortnite-bling" },
                { name: "Valorant", to: "/valorant-bling" },
              ].map((game) => (
                <li key={game.name}>
                  <Link to={game.to} className="text-gray-500 hover:text-yellow-400 text-sm flex items-center gap-1.5 transition-colors">
                    <span className="w-1.5 h-1.5 rounded-full bg-yellow-600" />
                    {game.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Visit */}
          <div>
            <h4
              className="text-yellow-500 font-bold text-sm uppercase tracking-widest mb-4"
              style={{ fontFamily: "'Orbitron', sans-serif" }}
            >
              Visit Us
            </h4>
            <a
              href="https://www.blingskins.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-gray-500 hover:text-yellow-400 text-sm transition-colors"
            >
              www.blingskins.com
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
            <p className="text-gray-600 text-xs mt-4">
              BlingSkins is not affiliated with EA, Epic Games, or Riot Games. All game names, logos, and trademarks are property of their respective owners.
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-yellow-900/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-xs">
            &copy; {new Date().getFullYear()} BlingSkins Hub. All rights reserved.
          </p>
          <p className="text-gray-700 text-xs">
            Made with passion for gaming aesthetics
          </p>
        </div>
      </div>
    </footer>
  )
}
